/** Normalize the persisted full-layer-set compare-and-swap revision. */
export function siteLayersRevision(value: unknown): number {
  return typeof value === 'number'
    && Number.isSafeInteger(value)
    && value >= 0
    ? value
    : 0;
}

/** Reject a stale full-array editor write before it can erase another writer. */
export function assertSiteLayersRevision(expected: number, liveValue: unknown): number {
  const live = siteLayersRevision(liveValue);
  if (live !== expected) {
    throw new Error('Site layers changed in another session. Reload the layers before saving.');
  }
  return live;
}
